module.exports = __webpack_public_path__ + "static/img/slider-validator.7fbb27e.png";


//////////////////
// WEBPACK FOOTER
// ./src/oldCode/components/slider-validator/images/slider-validator.png
// module id = 564
// module chunks = 2